








































import { defineComponent } from '@nuxtjs/composition-api'

import isEmpty from 'lodash/fp/isEmpty'

// Type
import { RegionalSettingInterface } from '@/types/cms/admin'

export default defineComponent({
  name: 'SupportTile',

  props: {
    tile: {
      type: Object as () => RegionalSettingInterface | undefined,
      required: false,
      default: undefined,
    },
    title: {
      type: String,
      required: true,
    },
    form: {
      type: String,
      required: true,
    },
  },

  setup() {
    // Check for toll free number, otherwise use phone number
    const getPhoneNumber = (phoneObject: RegionalSettingInterface['address']['phone']) => {
      if (phoneObject) {
        return !isEmpty(phoneObject.toll_free_number) ? phoneObject.toll_free_number : phoneObject.phone_number
      }
    }

    // Check for toll free number, otherwise use fax number
    const getFaxNumber = (faxObject: RegionalSettingInterface['address']['fax']) => {
      if (faxObject) {
        return !isEmpty(faxObject.toll_free_fax) ? faxObject.toll_free_fax : faxObject.fax_number
      }
    }

    return {
      getPhoneNumber,
      getFaxNumber,
    }
  },
})
